module.exports = __webpack_public_path__ + "static/media/emptyAgency.563ab881.jpg";